import { useTranslation } from 'react-i18next';
import { LegalPageLayout } from './LegalPageLayout';
import { LegalCompanyBlock } from './LegalCompanyBlock';

export function PrivacyPage() {
  const { t } = useTranslation();

  const sections = [
    {
      title: t('legal.privacy.section1Title'),
      body: t('legal.privacy.section1Body'),
    },
    {
      title: t('legal.privacy.section2Title'),
      body: t('legal.privacy.section2Body'),
    },
    {
      title: t('legal.privacy.section3Title'),
      body: t('legal.privacy.section3Body'),
    },
  ];

  return (
    <LegalPageLayout
      title={t('legal.privacy.title')}
      subtitle={t('legal.privacy.subtitle')}
    >
      <div className="space-y-8">
        <LegalCompanyBlock label={t('legal.privacy.controllerLabel')} />
        {sections.map((section, idx) => (
          <div key={idx}>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">
              {section.title}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {section.body}
            </p>
          </div>
        ))}
      </div>
    </LegalPageLayout>
  );
}
